"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMulticallContracts = void 0;
const multiContractCall_json_1 = __importDefault(require("./abis/multiContractCall.json"));
const utils_1 = require("./utils");
const getMulticallContracts = (address, web3) => {
    return (0, utils_1.getEVMContract)(multiContractCall_json_1.default, address, web3);
};
exports.getMulticallContracts = getMulticallContracts;
